var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{class:'modal fade ' + _vm.cls,staticStyle:{"display":"block"},attrs:{"id":"myModal","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true"}},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }